import { render, staticRenderFns } from "./BaseHeaderNew.vue?vue&type=template&id=42fd548e&scoped=true&"
import script from "./BaseHeaderNew.vue?vue&type=script&lang=js&"
export * from "./BaseHeaderNew.vue?vue&type=script&lang=js&"
import style0 from "./BaseHeaderNew.vue?vue&type=style&index=0&id=42fd548e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fd548e",
  null
  
)

export default component.exports